import { Environment, EnvironmentConfig, ROOT_TYPE } from "relay-runtime";

export function createRelayEnvironmentWithMissingFieldHandlers(
  config: EnvironmentConfig
) {
  return new Environment({
    ...config,
    missingFieldHandlers: [
      {
        kind: "pluralLinked",
        handle(field, record, argValues) {
          if (
            record != null &&
            record.getType() === ROOT_TYPE &&
            ["employeesByIds", "storeProductsByIds", "teamsByIds", "rolesByIds"].includes(
              field.name
            ) &&
            argValues.hasOwnProperty("ids")
          ) {
            return argValues.ids;
          }

          return undefined;
        },
      },
      {
        kind: "linked",
        handle(field, record, argValues) {
          if (
            record != null &&
            record.getType() === ROOT_TYPE &&
            [
              "node",
              "widget",
              "widgetNote",
              "routine",
              "teamScheduleEventItem",
              "image",
              "media",
              "video",
              "todo",
              "file",
              "media",
              "storeProduct",
            ].includes(field.name) &&
            argValues.hasOwnProperty("id")
          ) {
            return argValues.id;
          }

          return undefined;
        },
      },
      {
        kind: "linked",
        handle(field, record, argValues) {
          if (
            record != null &&
            record.getType() === "Team" &&
            field.name === "dailySchedule" &&
            argValues.hasOwnProperty("id")
          ) {
            return argValues.id;
          }

          return undefined;
        },
      },

      {
        kind: "linked",
        handle(field, record, argValues) {
          if (
            record != null &&
            record.getType() === "Storecast" &&
            field.name === "screen" &&
            argValues.hasOwnProperty("id")
          ) {
            return argValues.id;
          }

          return undefined;
        },
      },

      {
        kind: "linked",
        handle(field, record, argValues) {
          if (
            record != null &&
            record.getType() === "TodoCategory" &&
            field.name === "team" &&
            argValues.hasOwnProperty("id")
          ) {
            return argValues.id;
          }

          return undefined;
        },
      },
      {
        kind: "linked",
        handle(field, record, argValues) {
          if (
            record != null &&
            record.getType() === "Store" &&
            ["team", "employee", "productExpireBatch"].includes(field.name) &&
            argValues.hasOwnProperty("id")
          ) {
            return argValues.id;
          }
          return undefined;
        },
      },
    ],
  });
}
